var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useCookies } from './use-cookies';
import { useRequest } from './use-request';
export function useTrackEvent() {
    var cookies = useCookies().cookies;
    var csrfToken = cookies && cookies.YII_CSRF_TOKEN ? cookies.YII_CSRF_TOKEN : '';
    var execute = useRequest({ isAjaxRequest: true }).execute;
    var trackEvent = function (props) {
        execute({
            url: '/mixpanel/track',
            data: __assign(__assign({}, props), { YII_CSRF_TOKEN: csrfToken }),
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRFToken': csrfToken,
                'X-Requested-With': 'XMLHttpRequest',
            },
        });
    };
    return [trackEvent];
}
//# sourceMappingURL=use-track-event.js.map